// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/disparity/user/community.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.disparity.user.community',
	priority: 71,
	require: function(config, filter) {
		return rangeActive(filter.disparity && filter.disparity.user && filter.disparity.user.community, -10, 10)
	},
	run: function(config, filter, data, query) {
		var alias = 'r'
		if (config.ownerType !== F.OWNER_USER) {
			alias = 'ru'
			query.rename('r', 'ru')
		}
		if (config.userID) query.where(alias + '.user_id', '=', config.userID)
		query.select(alias + '.rating_value - g.game_rating_avg', 'uc_disparity')
		if (filter.disparity.user.community.from !== -10) {
			query.having('!uc_disparity', '>=', Util.adjustedRating(filter.disparity.user.community.from))
		}
		if (filter.disparity.user.community.to !== 10) {
			query.having('!uc_disparity', '<=', Util.adjustedRating(filter.disparity.user.community.to, true))
		}
	}
}
